import { render, staticRenderFns } from "./BillingManagementWrapper.vue?vue&type=template&id=7f0d30cd"
import script from "./BillingManagementWrapper.vue?vue&type=script&lang=js"
export * from "./BillingManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0d30cd')) {
      api.createRecord('7f0d30cd', component.options)
    } else {
      api.reload('7f0d30cd', component.options)
    }
    module.hot.accept("./BillingManagementWrapper.vue?vue&type=template&id=7f0d30cd", function () {
      api.rerender('7f0d30cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingAdjustmentManagement/BillingManagementWrapper.vue"
export default component.exports